//环信appKey配置项
export const DEFAULT_EASEMOB_APPKEY = '1166230925159121#xsms'
export const DEFAULT_EASEMOB_SOCKET_URL = '//im-api-v2.easemob.com/ws'
export const DEFAULT_EASEMOB_REST_URL = '//a1.easemob.com'
